<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-1">
      {{ $t("af:application.offline_under_review.title") }}
    </p>
    <p class="mb-5">{{ $t("af:application.offline_under_review.subtitle") }}</p>
    <application-template template="OFFLINE_IN_REVIEW"></application-template>
  </div>
</template>

<script>
export default {
  name: "ApplicationFlowOfflineUnderReview",
  components: {
    ApplicationTemplate: () => import("@/components/ApplicationTemplate.vue"),
  },
  props: {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
